import { type SortDirection, type v2 } from '@deque/billing-service-client';
import { type Paginated } from '@deque/pagination-utils';
import { useCallback } from 'react';

import useAPI, { type Methods, type State } from '~/common/hooks/useAPI';
import billingClient from '~/common/utils/billing-client/client-v2';

export interface TeamsState extends Omit<State<Paginated<v2.Team[]>>, 'data'> {
  teams: Paginated<v2.Team[]> | null;
}

export type UseTeamsState = TeamsState & Methods;

interface UseTeamsParams {
  token: string;
  enterpriseId: string;
  name?: string;
  page?: number;
  per_page?: number;
  sortBy?: v2.TeamSortableColumn;
  sortDir?: SortDirection;
}

const useTeams = ({
  token,
  enterpriseId,
  name,
  page,
  per_page,
  sortBy,
  sortDir
}: UseTeamsParams): UseTeamsState => {
  const dataLoader = useCallback(
    () =>
      billingClient.teams.list({
        token,
        enterpriseId,
        name,
        page,
        per_page,
        sortBy,
        sortDir
      }),
    [token, enterpriseId, name, page, per_page, sortBy, sortDir]
  );

  const state = useAPI(dataLoader);

  return {
    teams: state.data || null,
    loading: state.loading,
    error: state.error,
    refresh: state.refresh
  };
};

export default useTeams;
